import React, { useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { T } from "services/lang/LanguageService";

import "./EapsmLicenseManager.scss";
import UsersTable from "./UsersTable";
import LicensesTable from "./LicensesTable";

function EapsmLicenseManager() {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  return (
    <TabView activeIndex={activeIndex} onTabChange={e => setActiveIndex(e.index)}>
      <TabPanel header={T("word.users")}>
        <UsersTable />
      </TabPanel>
      <TabPanel header={T("word.licenses")}>
        <LicensesTable />
      </TabPanel>
      <TabPanel header={T("word.eapsm.license-assignation")}>
        {T("word.eapsm.license-assignation")}
      </TabPanel>
    </TabView>
  );
}

export default EapsmLicenseManager;
